export enum UserGenderEnum {
  MALE = "MALE",
  FEMALE = "FEMALE",
}

export enum UserVerificationStatusEnum {
  VERIFIED = "VERIFIED",
  UNVERIFIED = "UNVERIFIED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export enum PlayerStrongFootEnum {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}
